import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { Tab } from 'components/atoms';
import { iconType } from 'types';

const TabsList = ({ tabs }) => (
  <Tabs>
    {tabs
      && tabs.length > 0
      && tabs.map(
        ({
          id,
          icon,
          onClose,
          isActive,
          isClosable,
          onClick,
          to,
          isEditor,
          title,
        }) => (
          <Tab
            key={id}
            id={id}
            icon={icon}
            isClosable={isClosable}
            onClose={onClose}
            onClick={onClick}
            to={to}
            isEditor={isEditor}
            modifiers={[isActive ? 'active' : '']}
            title={title}
          />
        )
      )}
  </Tabs>
);

TabsList.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      icon: iconType.isRequired,
      onClose: PropTypes.func,
      isActive: PropTypes.bool,
      isClosable: PropTypes.bool,
      isEditor: PropTypes.bool,
      onClick: PropTypes.func,
    })
  ),
};

TabsList.defaultProps = {
  tabs: [],
};

const Tabs = styled.div`
  display: flex;
  background-color: ${props => props.theme.colors.bgLighterS};
  padding-left: ${props => props.theme.spacing.xs};
`;

export default TabsList;
